import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconFolderOpenStyle0 = cosmosIconCss;

const CosmosIconFolderOpen$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconFolderOpen extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '991ab1ab7e7f31c7e78150d6a86ebfaa164bcc95', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '3b58a80b18d1ed6cbfb24386844afec7f70ba637', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'bb0293e00fa6794e815bb60345f636031891815d', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M13 5.5h5.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-6.19a.5.5 0 0 1-.44-.28L11 5H4.45v4.58a.5.5 0 0 1 0 .21l-.88 1.89a.3.3 0 0 1-.27.17.29.29 0 0 1-.3-.3V4a.5.5 0 0 1 .5-.5h8.19a.5.5 0 0 1 .44.28L13 5.5ZM7.35 9a.49.49 0 0 0-.45.29l-3.81 8.14a.4.4 0 0 0 .36.57h12.79a.49.49 0 0 0 .45-.29l3.81-8.14a.4.4 0 0 0-.36-.57H7.35Zm11.06 1.5-2.81 6H5.18l2.82-6h10.41Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconFolderOpenStyle0; }
}, [1, "cosmos-icon-folder-open", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-folder-open"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-folder-open":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconFolderOpen$1);
            }
            break;
    } });
}

const CosmosIconFolderOpen = CosmosIconFolderOpen$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconFolderOpen, defineCustomElement };
